import useSWR from "swr";
import { HandlerApiGet } from "./axios";

export const useGetAPI = (url: string | null) => {
  const { data, isLoading, mutate, error } = useSWR(url, (url) =>
    HandlerApiGet(url)
  );
  return { data, isLoading, mutate, error };
};

export const useGetApiToken = (url: string, token: any) => {
  const shouldFetch = token !== null;

  const { data, isLoading, mutate, error } = useSWR(
    shouldFetch ? url : null,
    (url) => HandlerApiGet(url, token)
  );

  return { data, isLoading, mutate, error };
};
